module.exports = __webpack_public_path__ + "static/media/Rebecca-de-Ravenel-Pink-Coral-Mamacita-4-Drop-Earrings-Lyst_thumb.2bb76f7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/jewellery/Rebecca-de-Ravenel-Pink-Coral-Mamacita-4-Drop-Earrings-Lyst_thumb.png
// module id = 244
// module chunks = 0